import { render, staticRenderFns } from "./SupplierModels.vue?vue&type=template&id=ab584914&scoped=true"
import script from "./SupplierModels.vue?vue&type=script&lang=js"
export * from "./SupplierModels.vue?vue&type=script&lang=js"
import style0 from "./SupplierModels.vue?vue&type=style&index=0&id=ab584914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab584914",
  null
  
)

export default component.exports